const SESSION_TOKEN = 'session_token'

export const getToken = () => {
  return window.localStorage.getItem(SESSION_TOKEN)
}

export const saveToken = (token) => {
  window.localStorage.setItem(SESSION_TOKEN, token)
}

export const destroyTokens = () => {
  const keysToRemove = [SESSION_TOKEN]
  keysToRemove.forEach((key) => localStorage.removeItem(key))
}

export default {
  getToken,
  saveToken,
  destroyTokens
}
